<!-- <div class="preloader" [hidden]="load">
    <div class="loading">
        <img src="assets/images/loader/loader.svg" alt="">
    </div>
</div> -->

<app-loading [hidden]="load"></app-loading>

<section class="page-title page-title-layout3 text-center bg-overlay bg-parallax " style="
    background-size: cover; background-position: center center;">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <h1 class="pagetitle__heading mb-10">Research-Team</h1>
                <!-- <nav>
                    <ol class="breadcrumb justify-content-center mb-0">
                        <li class="breadcrumb-item"><a routerLink="/home">home</a></li>
                        <li aria-current="page" class="breadcrumb-item active">Research-Team</li>
                    </ol>
                </nav> -->
            </div>
        </div>
    </div>
</section>

<section class="portfolio-layout3">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-3">
                <ul class="portfolio-filter  justify-content-center list-unstyled" style="padding: 11px;">
                    <li [ngClass]="{'active2': selectedItem == null}" routerLink="/our-team"><a>All</a></li>
                    <li *ngFor="let item of arrayTeamCategory" [ngClass]="{'active2': selectedItem == item.postID}">
                        <a style="cursor: pointer;" routerLink="/our-team/{{item.postID}}" (click)="getTeam(item.postID)">
                            {{item.postTitle}}
                        </a>
                    </li>
                </ul>
            </div>
            <div class="row col-sm-12 col-md-12 col-lg-9 marginL"  >



<ng-container   *ngFor="let a of array2">
  <div *ngIf="a.ourTeams.length != 0" class="col-sm-12 col-md-12 col-lg-12">
    <h4 class="job-item__title job-item__type"  style="  font-size: 13px;
    text-transform: capitalize;
    background-color: #019cce;
    color: #fff;
    padding: 5px 8px;
    margin-bottom: 15px !important;text-align: center;border-radius: 0px 0 40px 40px !important;">{{a.Title}}</h4> </div>
    
                <div class="col-sm-6 col-md-6 col-lg-4" *ngFor="let ourTeam of a.ourTeams">
                  
                    <div class="member ">
                        <div class="member__img">
                            <img src="https://api2.wcrg.org:444/images/post/{{ourTeam.postImage}}" alt="member img">
                           
                            <div class="member__hover">
                                <div class="member__content-inner">
                                    <ul style="flex-direction: row-reverse !important;" class="social-icons justify-content-center list-unstyled mb-0">
                                        <li>
                                            <a href="{{ourTeam.team_Linkedin}}" target="_blank">
                                                <i class="fa fa-linkedin"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="{{ourTeam.team_GoogleSchoolar}}" target="_blank">
                                                <i class="ai ai-google-scholar"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="{{ourTeam.team_Publons}}" target="_blank">
                                                <i class="ai ai-publons "></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="member__info">
                            <a style="color: #000;" routerLink='../OurTeamDetails/{{ourTeam.postID}}'>
                                <h5 class="member__name">
                                    {{ourTeam.postTitle}}
                                </h5>
                                <p class="member__desc">
                                    {{ourTeam.postSubTitle}}
                                </p>
                            </a>
                        </div>
                    </div>
                </div>
              </ng-container>
            </div>
        </div>
    </div>
  
</section>
